import getCSRAuthToken from '@/app/api/CSR/getCSRAuthToken'
import { ApolloLink, DefaultContext } from '@apollo/client'

const authLinkCSR = new ApolloLink((operation, forward) => {
  operation.setContext(({ headers }: DefaultContext) => {
    const token = getCSRAuthToken() || ''
    return {
      headers: {
        token,
        ...headers,
      },
    }
  })
  return forward(operation)
})

export default authLinkCSR
